<template>
	<span v-html="highlighted"></span>
</template>

<script>
function escapeHtml(s) {
	return String(s)
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;");
}

function toRegexList(queries) {
	if (!queries) {
		return [];
	}
	const list = Array.isArray(queries) ? queries : [queries];
	return list
		.filter((q) => q != null && q !== "")
		.map((q) => {
			if (q instanceof RegExp) {
				const flags = q.flags.includes("g") ? q.flags : `${q.flags}g`;
				return new RegExp(q.source, flags);
			}
			const escaped = String(q).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
			return new RegExp(escaped, "g");
		});
}

function styleToString(style) {
	if (!style || typeof style !== "object") {
		return "";
	}
	return Object.keys(style)
		.map((k) => `${k}:${style[k]}`)
		.join(";");
}

/** Vue 3 text highlighter for URL validator (`queries` / `highlightStyle` / `text`). */
export default {
	name: "TextHighlight",
	props: {
		text: {
			type: String,
			default: "",
		},
		queries: {
			type: [String, RegExp, Array],
			default: "",
		},
		highlightStyle: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		highlighted() {
			const escaped = escapeHtml(this.text || "");
			const regexes = toRegexList(this.queries);
			if (!regexes.length || !escaped) {
				return escaped;
			}
			const style = styleToString(this.highlightStyle);
			const wrap = (m) => `<span class="text-highlight" style="${style}">${m}</span>`;
			let out = escaped;
			for (const re of regexes) {
				out = out.replace(re, (m) => wrap(m));
			}
			return out;
		},
	},
};
</script>
